import React, {useCallback} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useTranslationAdmin from "../useTranslationAdmin";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import Table from "react-bootstrap/Table";
import WaitForData from "../../common/data-fetching/WaitForData";
import useQueryRecruiterAdminSearch from "../search/useQueryRecruiterAdminSearch";
import TypeUtils from "../../../utils/TypeUtils";
import TrueIcon from "@material-ui/icons/Check";
import ApplicationByRecruiterCountItem from "../search/ApplicationByRecruiterCountItem";
import TruncateText from "./TruncateText";
import ActionLink from "../../common/widgets/ActionLink";
import {useHistory} from "react-router-dom";
import * as ROUTES from "../../../constants/routes";
import queryString from "query-string";
import DisplayDayIso from "./DisplayDayIso";
import CandidateApprovalStatusEnum from "../../candidates/CandidateApprovalStatusEnum";
import ApprovedApplicationByRecruiterCountItem from "../search/ApprovedApplicationByRecruiterCountItem";

export default function RecruiterList(/*props*/) {
  const {
    data: recruiters,
    loading,
    errors,
  } = useQueryRecruiterAdminSearch(
    1000,
    {},
    "CREATED_AT_DESC"
  );

  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading || loading, "RecruiterList");

  const history = useHistory();

  const goToAllApplications = useCallback(recruiterId => {
    history.push({
      pathname: ROUTES.EMPLOYER_ADMIN_APPLICATIONS,
      search: queryString.stringify({ recruiterId } ),
    });
  }, [history]);

  const goToApprovedApplications = useCallback(recruiterId => {
    history.push({
      pathname: ROUTES.EMPLOYER_ADMIN_APPLICATIONS,
      search: queryString.stringify({ recruiterId, candidateApprovalStatus: CandidateApprovalStatusEnum.APPROVED } ),
    });
  }, [history]);

  const columnsLabels = [
    t("admin:admin_recruiter_date_column_label"),
    t("admin:admin_recruiter_name_column_label"),
    t("admin:admin_recruiter_phone_column_label"),
    t("admin:admin_recruiter_email_column_label"),
    t("admin:admin_recruiter_jobTitle_column_label"),
    t("admin:admin_recruiter_location_column_label"),
    t("admin:admin_recruiter_about_column_label"),
    t("admin:admin_recruiter_active_column_label"),
    t("admin:admin_recruiter_application_count_column_label"),
    t("admin:admin_recruiter_approvedApplication_count_column_label")
  ];

  return (
    <>
      <WaitForData
        loading={loading}
        errors={errors}
        onLoaded={() => (
          <Row className="widget-block">
            <Col>
              <Table striped hover responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    {columnsLabels.map((item, i) => (
                      <td key={i}>{item}</td>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {recruiters["nodes"].map((item, i) => (
                    <tr key={i}>
                      <th>{i + 1}</th>
                      <td><DisplayDayIso date={item.createdAt} /></td>
                      <td>{TypeUtils.arrayRemoveNullOrEmpty([item.firstName, item.lastName]).join(" ")}</td>
                      <td>{item.phone}</td>
                      <td><TruncateText title={t("admin:admin_recruiter_email_column_label")} text={item.email} length={15}/></td>
                      <td><TruncateText title={t("admin:admin_recruiter_jobTitle_column_label")} text={item.jobTitle} length={15}/></td>
                      <td>{TypeUtils.arrayRemoveNullOrEmpty([item.city, item.country]).join(", ")}</td>
                      <td><TruncateText title={t("admin:admin_recruiter_about_column_label")} text={item.aboutMe} length={15}/></td>
                      <td>{item.isActiveAccount ? <TrueIcon/> : ""}</td>
                      <td><ActionLink onClick={() => goToAllApplications(item._id)}><ApplicationByRecruiterCountItem recruiterId={item._id}/></ActionLink></td>
                      <td><ActionLink onClick={() => goToApprovedApplications(item._id)}><ApprovedApplicationByRecruiterCountItem recruiterId={item._id}/></ActionLink></td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        )}
      />
    </>
  );
}
